// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__AQNCs","requiredAsterisk":"Info_requiredAsterisk__222G9"};